<template>
  <b-modal scrollable centered size="lg" id="depositAccModal" title="Xác nhận đặt cọc tài khoản">
      <div v-if="this.account">

        <table class="table table-bordered">
          <th colspan="2">
            <span id="acc-info">Thông tin tài khoản #{{ this.account.id }}</span>
          </th>
        </table>

        <table class="table table-bordered">
          <tr>
            <td class="col-sm-6">Giá tiền:</td>
            <td class="text-right col-sm-6 text-primary" id="acc-price"><b>{{ Helper.formatMoney(this.account.price) }}<sup>vnd</sup></b></td>
          </tr>
        </table>

        <div class="col-md-9 mx-auto">
          <table class="w-100">
            <tr>
              <td class="p-2 text-danger"><b>Số tiền đặt cọc</b></td>
              <td class="p-2">
                <input type="text" class="form-control text-danger" :value="Helper.formatMoney(this.account.deposit_price)" disabled>
              </td>
            </tr>
            <tr>
              <td class="p-2 text-danger"><b>Trả lần 2</b></td>
              <td class="p-2">
                <input type="text" class="form-control text-danger" :value="Helper.formatMoney(this.account.last_deposit_price)" disabled>
                Thời gian thanh toán <b>lần 2 {{ this.account.deposit_deadline }}</b>
                <!-- {{ (this.account.package && this.account.package.deposit_day) ? this.account.package.deposit_day : 0 }} ngày -->
              </td>
            </tr>
            <tr>
              <td class="p-2 text-danger"><b>Số tiền nhận lại nếu huỷ đặt cọc</b></td>
              <td class="p-2">
                <input type="text" class="form-control text-danger" :value="Helper.formatMoney(this.account.deposit_price_cancel)" disabled>
              </td>
            </tr>
          </table>
        </div>

        <table class="table table-bordered" v-if="this.message">
          <tr>
            <td colspan="2">
              <label id="message" :class="this.isSuccessMsg ? 'text-success' : 'text-danger'" ><b>{{ this.message }}</b></label>
            </td>
          </tr>
        </table>

        <hr>

        <br>
        <button type="button" class="btn btn-sm btn-success btn-block" @click="handleDepositAccount()" :disabled="btn_disabled">Thanh toán ngay</button>
        <br>

        <div>
          <b-alert show variant="success">
            <b>Hệ thống đặt cọc nick tự động 100%, không mất thêm bất cứ chi phí nào !!!</b>
          </b-alert>

          <div class="card" v-if="this.account.package && this.account.package.deposit_descript">
            <div class="card-body">
              <p style="margin: 0;" class="card-title"><b>Thông tin phương thức đặt cọc</b></p>
              <div :style="{height: (expand_descript == true ? 'auto' : '100px')}" class="overflow-hidden" v-html="this.account.package.deposit_descript"></div>
            </div>
            <div class="card-footer text-center" style="cursor: pointer;">
              <span class="text-primary h5" style="cursor: pointer;" v-if="!expand_descript" @click="expand_descript = true">Xem thêm <i class="linearicons-chevron-down"></i></span>
              <span class="text-primary h5" style="cursor: pointer;" v-if="expand_descript" @click="expand_descript = false">Thu gọn <i class="linearicons-chevron-up"></i></span>
            </div>
          </div>
        </div>
      </div>

      <template #modal-footer>
        <div></div>
      </template>
    </b-modal>
</template>

<script>
export default {
  props: {
      user: {
        Type: Object,
        default() {
          return {};
        }
      },
      currentWallet: {
        Type: Array,
        default() {
          return [];
        }
      },
      account: {
        Type: Object,
        default() {
          return {};
        }
      },
      categoryTypes: {
        Type: Object,
        default() {
          return {};
        }
      },
      website: {
        Type: Object,
        data() {
          return {}
        }
      }
  },

  data() {
    return {
      btn_disabled: false,
      message: '',
      isSuccessMsg: false,
      expand_descript: false,
    }
  },

  methods: {
    appendMessage(message, success = false) {
      this.message = message;
      this.isSuccessMsg = success;
    },

    async handleDepositAccount() {
      this.btn_disabled = true
      try {
        const uri = this.route('fe_deposit_account', {domain: this.website.domain});
        const response = await this.Request.post(uri, { id: this.account.id });
        if (response.data.status === false) {
          this.appendMessage(response.data.message);
        } else {
          await this.$swal.fire({
              icon: 'success',
              title: 'Thành Công',
              html: response.data.message,
            }
          );

          window.location.href = this.route('lsdatcoc', {domain: this.website.domain});
        }

        this.btn_disabled = false;
      } catch (e) {
        const errorMessages = this.Request.errors(e.response);
        await this.$swal({
          icon: 'error',
          title: 'Error',
          text: this._.isEmpty(errorMessages) ? e.response.data.error : errorMessages[0],
        });

        this.btn_disabled = false;
      }
    }
  }
}
</script>

<style>

</style>